/** Available role mimetypes used when calling api to differentiate data models per role */
export enum RoleMimetype {
  DEFAULT = 'application/json',
  ADMIN = 'application/co.backbone.api.admin.v1+json',
  CREATIVE = 'application/co.backbone.api.creative.v1+json',
  CLIENT = 'application/co.backbone.api.client.v1+json',
}